import { exportExcelFactory } from '../../utils/export-excel';
import { RequirementColumn, Department } from '../../types/data';
import { DownloadIcon } from 'src/components/ui-icons/upload';

type ExcelExportReportFactoryProps = {
  data: RequirementColumn[];
  departments: Department[];
  params: {
    group: string;
  };
}

function ExcelExportReportFactory({ data, departments, params}: ExcelExportReportFactoryProps) {
  return <button className="inline-flex items-center border font-medium rounded-md px-4 justify-center gap-x-2 text-darkblue bg-white hover:bg-gray-50 shadow-custom text-base lg:px-6 py-3 sm:px-4 ml-auto" onClick={() => exportExcelFactory(data, departments, params)}><DownloadIcon /> Скачать в Excel</button>;
}

export default ExcelExportReportFactory;
